import TransactionComponent from "@/components/api/TransactionComponent";
import {handleApiError} from "@/utils/VuexUtil";

const MODULE_NAME = 'transaction'

const state = {
    isLoading: false,
    errors: null,
    result: null,
    totalPages: null,
    total: null
}

export const TransactionActionTypeEnum = {
    get: '['+MODULE_NAME+'] get',
    list: '['+MODULE_NAME+'] list'
};

const MutationTypeEnum = {
    getStart: '['+MODULE_NAME+'] getStart',
    getSuccess: '['+MODULE_NAME+'] getSuccess',
    getFailure: '['+MODULE_NAME+'] getFailure',
    listStart: '['+MODULE_NAME+'] listStart',
    listSuccess: '['+MODULE_NAME+'] listSuccess',
    listFailure: '['+MODULE_NAME+'] listFailure',
};

const getters = {
    transactionIsLoading: (state)=> state.isLoading,
    transactionGetResult: (state)=> state.result,
    transactionGetErrors: (state) => state.errors,
    transactionGetTotalPages: (state) => state.totalPages,
    transactionGetTotal: (state) => state.total
}

const mutations =  {
    [MutationTypeEnum.getStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.getSuccess](state, response) {
        state.isLoading = false
        if (response) state.result = response
    },
    [MutationTypeEnum.getFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    },

    [MutationTypeEnum.listStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.listSuccess](state, response) {
        state.isLoading = false
        if (response) {
            state.result = response.result
            state.currentPage = response.currentPage
            state.totalPages = response.totalPages
            state.total = response.total
        }
    },
    [MutationTypeEnum.listFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    }
}

const actions = {
    async [TransactionActionTypeEnum.get](context, request) {
        context.commit(MutationTypeEnum.getStart)
        try {
            const response = await TransactionComponent.get(request);
            context.commit(MutationTypeEnum.getSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.getFailure, formattedError);
            return formattedError;
        }
    },
    async [TransactionActionTypeEnum.list](context, request) {
        context.commit(MutationTypeEnum.listStart)
        try {
            const response = await TransactionComponent.list(request);
            context.commit(MutationTypeEnum.listSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.listFailure, formattedError);
            return formattedError;
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}